import React, { useState, useEffect, useContext } from 'react';
import { Card, Button, Input } from 'reactstrap'
import Countdown from '../../components/Countdown'
import swal from 'sweetalert';
import styled from 'styled-components'
import { DateTime } from 'luxon';
import { AuthContext } from '../../contexts/AuthContext'
import api from '../../services/api';
import { toast } from 'react-toastify'
const Wrapper = styled.div`
  padding: 10px;
`;
const TitleTag = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const Title = styled.h5`
  font-size: 24px;
  font-weight: bold;
  color: #73777f;
`;

const GoBack = styled.div`
 margin-left: auto;
 cursor: pointer;
 text-transform: uppercase;
font-weight: bold;
color: #73777f;
`;


const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 70vh;
  overflow: auto;
  padding: 20px;
`;

const SideContainer = styled.div`
  display: flex;
  width: 25%;
  border-left: 1px solid #4444;
  padding: 5px;
  color: #73777f;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  @media (max-width: 768px) {
    width: 100%
  }
`;

const SideTitle = styled.h5`
  font-size: 24px;
  font-weight: bold;
  color: #73777f;
`;

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 5px; 
`

const QuestionHeader = styled.div`
  display: flex;
  flex-direction: row;
  background-color: rgba(115, 119, 127, 0.08);
  padding: 5px;
  justify-content: flex-start;
`

const QuestionNumber = styled.h1`
  color: #73777f;
  font-size: 26px;
  font-weight: bold;
  margin-right: 15px;
  &::after{
    content: "."
  }
`
const QuestionTitle = styled.h5`
  color: #73777f;
  font-size: 16px;
  white-space: pre-line;
`
const QuestionAnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

const QuestionAnswer = styled.div`
  color: ${props => props.active ? 'rgba(41, 107, 169, 1)' : '#73777f'};
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  width: 100%;
  margin: 10px;
  cursor: pointer;
  white-space: pre-line;
`

const Footer = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

const NextQuestion = styled.div`
 cursor: pointer;
 text-transform: uppercase;
font-weight: bold;
color: #73777f;
`

const PreviousQuestion = styled.div`
 cursor: pointer;
 text-transform: uppercase;
font-weight: bold;
color: #73777f;
`

function LectureExams(props) {
  const [end, setEnd] = useState(DateTime.local().plus({ days: 1 }));
  const [test, setTest] = useState({})
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [question, setQuestion] = useState({})
  const [answers, setAnswers] = useState([])
  const [ended, setEnded] = useState(false)
  const [showEnd, setShowEnd] = useState(false)
  const { auth } = useContext(AuthContext)
  const [reloadData, setReloadData] = useState(false)
  const [idMockAnswer, setIdMockAnswer] = useState('');
  useEffect(() => {
    api.get(`/mockTest/${props.match.params.id}`).then(async res => {
      setTest(res.mockTest)
      setQuestion(res.mockTest.questions[0])
      setReloadData(!reloadData)
    })
  }, [])

  const callNickNameSwal = () =>
    swal({
      title: "Atenção",
      text: `Defina o apelido que você deseja usar.`,
      icon: "warning",
      content: "input",
      buttons: {
        cancel: "Voltar",
        confirm: "Confirmar"
      },
    }).then(nickName => {
      if (nickName === null) {
        props.history.goBack();
      } else if (!nickName)
        callNickNameSwal()
      else {
        api.post('/mockTest/start', { idUser: auth.user._id, idMockTest: props.match.params.id, nickname: nickName }).then(res => {
          setShowEnd(true)
          setAnswers(test.questions.map(q => ({ question: q._id, answer: null })))
          setEnd(DateTime.fromISO(res.mockAnswer.timestamps.createdAt).plus({ minutes: test.duration }))
          setIdMockAnswer(res.mockAnswer._id);
        })
      }
    })

  useEffect(() => {
    if (test._id) {
      api.get(`/mockAnswer/${props.match.params.id}`).then(res => {
        if (!res.mockAnswer) {
          swal({
            title: "Atenção",
            text: `Você realmente deseja iniciar este simulado? Você tera ${test.duration} minutos para realizar este simulado.`,
            icon: "warning",
            buttons: {
              cancel: "Voltar",
              confirm: "Iniciar"
            },
            dangerMode: true
          }).then(value => {
            if (value)
              swal({
                title: "Atenção",
                text: `Você deseja publicar seu nome ou utilizar um apelido?`,
                icon: "warning",
                buttons: {
                  cancel: "Voltar",
                  confirm: "Sim",
                  apelido: {
                    text: "Usar apelido",
                    value: "nickname",
                  }
                },
                dangerMode: true
              }).then(nickNameResponse => {
                if (!nickNameResponse) {
                  props.history.goBack();
                } else if (nickNameResponse === "nickname") {
                  callNickNameSwal()
                } else {
                  api.post('/mockTest/start', { idUser: auth.user._id, idMockTest: props.match.params.id, nickname: auth.user.name }).then(res => {
                    setShowEnd(true)
                    setAnswers(test.questions.map(q => ({ question: q._id, answer: null })))
                    setEnd(DateTime.fromISO(res.mockAnswer.timestamps.createdAt).plus({ minutes: test.duration }))
                    setIdMockAnswer(res.mockAnswer._id);
                  })
                }
              })
            else
              props.history.goBack();
          })
        } else {
          if (!res.mockAnswer.isComplete) {
            setShowEnd(true)
            setIdMockAnswer(res.mockAnswer._id);
            setAnswers(res.mockAnswer.answers)
            setEnd(DateTime.fromISO(res.mockAnswer.timestamps.createdAt).plus({ minutes: test.duration }))
          } else {
            props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.classId}/answers/${props.match.params.id}`)
          }
        }
      })
    }
  }, [reloadData])
  const previousQuestion = () => {
    setCurrentQuestion(currentQuestion - 1);
    setQuestion(test.questions[currentQuestion - 1])
  }
  const nextQuestion = () => {
    setCurrentQuestion(currentQuestion + 1);
    setQuestion(test.questions[currentQuestion + 1])
  }

  const selectAnswer = (answer) => {
    let newAnswers = answers;
    newAnswers[currentQuestion] = {
      question: test.questions[currentQuestion]._id,
      answer
    }
    setAnswers([...newAnswers]);
  }
  const endTest = () => {
    swal("Atenção!", "Seu tempo para responder o simulado terminou!", "error").then(async () => {
      const res = await api.post('/mockTest/finishExpired', { idUser: auth.user._id, idMockAnswer, answers })
      props.history.goBack();
    });
    setEnded(true)
  }

  const checkTestFinish = () => {
    const qtyQuestions = test.questions.length;
    const qtyAnswers = answers.filter(a => {
      if (a.answer != null)
        return true
      return false
    }).length
    if (qtyAnswers < qtyQuestions) {
      swal({
        title: "Atenção",
        text: "Você não terminou de responder a todas as questões",
        icon: "warning",
        buttons: {
          cancel: "Voltar",
          confirm: "Finalizar"
        },
        dangerMode: true
      }).then(value => {
        if (value)
          finishTest()
      })
    } else {
      swal({
        title: "Atenção",
        text: "Você realmente deseja finalizar o simulado?",
        icon: "info",
        buttons: {
          cancel: "Voltar",
          confirm: "Finalizar"
        },
        dangerMode: true
      }).then(value => {
        if (value)
          finishTest()
      })
    }
  }

  const finishTest = async () => {
    const res = await api.post('/mockTest/finish', { idUser: auth.user._id, idMockAnswer, answers })
    if (res) {
      toast.success('Simulado enviado com sucesso!')
      props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.classId}/answers/${props.match.params.id}`)
    }
  }

  const optionName = ["a", "b", "c", "d", "e"];
  return (
    <Wrapper>
      <TitleTag>
        <Title>{test.title}</Title>
        <GoBack onClick={() => props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.classId}`)}>Voltar</GoBack>
      </TitleTag>
      <Card>
        {showEnd &&
          <ContentWrapper>
            {test.questions && <QuestionsContainer>
              <QuestionWrapper>
                <QuestionHeader>
                  <QuestionNumber>{currentQuestion + 1}</QuestionNumber>
                  <QuestionTitle>
                    {question.text}
                  </QuestionTitle>
                </QuestionHeader>
                <QuestionAnswersWrapper>
                  {question.options && question.options.map((answer, index) => {
                    return <QuestionAnswer active={answers[currentQuestion] ? answers[currentQuestion].answer === index : false} onClick={() => selectAnswer(index)} key={`answer_${question._id}_${index}`}>
                      <Input type="radio" name={`radio${currentQuestion}`} checked={answers[currentQuestion] ? answers[currentQuestion].answer === index : false} />
                      {optionName[index]})&nbsp;{answer}
                    </QuestionAnswer>
                  })}
                </QuestionAnswersWrapper>
              </QuestionWrapper>
              <Footer>
                {currentQuestion !== 0 && <PreviousQuestion onClick={() => previousQuestion()}>Anterior</PreviousQuestion>}
                {currentQuestion < (test.questions.length - 1) && <NextQuestion onClick={() => nextQuestion()} > Próxima</NextQuestion>}
              </Footer>
            </QuestionsContainer>}
            <SideContainer>
              <SideTitle>Instruções</SideTitle>
              <div>Responda o simulado preferencialmente sem consulta</div>
              {showEnd && <div>
                {!ended && <Countdown end={end} action={() => endTest()} />}
              </div>}
              <Button color="primary" onClick={() => checkTestFinish()}>
                Finalizar
            </Button>
            </SideContainer>
          </ContentWrapper>}
      </Card>
    </Wrapper >
  );
}

export default LectureExams;